module.exports = __webpack_public_path__ + "img/theme4.f24782c4.png";